<template>
  <div class="VoiceRecorder">
    <!-- <canvas id="visualizer"/>

    <div id="buttons" class="VoiceRecorder__buttons">
        <button class="record">Record</button>
        <button class="stop">Stop</button>
    </div> -->


    <div class="wrapper">

      <header>
        <h1>Web dictaphone</h1>
      </header>

      <section class="main-controls">
        <canvas class="visualizer" height="60px"></canvas>
        <div id="buttons">
          <button class="record">Record</button>
          <button class="stop">Stop</button>
        </div>
      </section>

      <section class="sound-clips">

      </section>

    </div>


  </div>
</template>

<script>

import gsap from "gsap"

export default {

  name: 'VoiceRecorder',
  data: ()=>({
  }),
  mounted() {
    console.log('VoiceRecorder'); 

    // set up basic variables for app

    const record = document.querySelector('.record');
    const stop = document.querySelector('.stop');
    const soundClips = document.querySelector('.sound-clips');
    this.canvas = document.querySelector('.visualizer');
    const mainSection = document.querySelector('.main-controls');

    // disable stop button while not recording

    stop.disabled = true;

    // visualiser setup - create web audio api context and canvas

    this.audioCtx;
    this.canvasCtx = this.canvas.getContext("2d");

    //main block for doing the audio recording

    if (navigator.mediaDevices.getUserMedia) {
      console.log('getUserMedia supported.');

      const constraints = { audio: true };
      let chunks = [];

      let onSuccess = (stream)=> {
        const mediaRecorder = new MediaRecorder(stream);

       
        record.onclick = ()=> {

          this.visualize(stream);

          mediaRecorder.start();
          console.log(mediaRecorder.state);
          console.log("recorder started");
          record.style.background = "red";

          stop.disabled = false;
          record.disabled = true;

        }

        stop.onclick = function() {
          mediaRecorder.stop();
          console.log(mediaRecorder.state);
          console.log("recorder stopped");
          record.style.background = "";
          record.style.color = "";

          // mediaRecorder.requestData();

          stop.disabled = true;
          record.disabled = false;

        }

        mediaRecorder.onstop = (e)=> {

          console.log("data available after MediaRecorder.stop() called.");

          cancelAnimationFrame(this.raf);

          // const clipName = prompt('Enter a name for your sound clip?','My unnamed clip');

          const clipContainer = document.createElement('article');
          const clipLabel = document.createElement('p');
          const audio = document.createElement('audio');
                audio.id = 'source'

          const playButton = document.createElement('button');
                playButton.textContent = 'Play';
                playButton.className = 'play';

          const deleteButton = document.createElement('button');
                deleteButton.textContent = 'Delete';
                deleteButton.className = 'delete';


          // if(clipName === null) {
          //   clipLabel.textContent = 'My unnamed clip';
          // } else {
          //   clipLabel.textContent = clipName;
          // }

          clipContainer.appendChild(audio);
          // clipContainer.appendChild(clipLabel);
          clipContainer.appendChild(playButton);
          clipContainer.appendChild(deleteButton);
          soundClips.appendChild(clipContainer);

          // audio.controls = true;
          // const blob = new Blob(chunks, { 'type' : 'audio/ogg; codecs=opus' });
          const blob = new Blob(chunks, { 'type' : 'audio/wav;' });
          chunks = [];
          const audioURL = window.URL.createObjectURL(blob);
          audio.src = audioURL;
          console.log("recorder stopped");

          // gsap.delayedCall(1, ()=>{
          //   console.log('xxxxxx');
          //   audio.play()
          // })

          deleteButton.onclick = function(e) {
            let evtTgt = e.target;
            evtTgt.parentNode.parentNode.removeChild(evtTgt.parentNode);
          }

          playButton.onclick = ()=>{
            this.audioCtx = null
            this.visualizeAudio()
            audio.play()

          }

          // clipLabel.onclick = function() {
          //   const existingName = clipLabel.textContent;
          //   const newClipName = prompt('Enter a new name for your sound clip?');
          //   if(newClipName === null) {
          //     clipLabel.textContent = existingName;
          //   } else {
          //     clipLabel.textContent = newClipName;
          //   }
          // }
        }

        mediaRecorder.ondataavailable = function(e) {
          chunks.push(e.data);
        }
      }

      let onError = function(err) {
        console.log('The following error occured: ' + err);
      }

      navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);

    } else {
       console.log('getUserMedia not supported on your browser!');
    }

  },
  methods:{ 

    visualize(stream){

      console.log(stream);

      if(!this.audioCtx) {
        this.audioCtx = new AudioContext();
      }

      const source = this.audioCtx.createMediaStreamSource(stream);

      this.analyser = this.audioCtx.createAnalyser();
      this.analyser.fftSize = 2048;
      this.bufferLength = this.analyser.frequencyBinCount;
      this.dataArray = new Uint8Array(this.bufferLength);

      source.connect(this.analyser);
      //analyser.connect(audioCtx.destination);

      this.raf = requestAnimationFrame(this.draw);

      // function 
    },



     visualizeAudio(){
  
      if(!this.audioCtx) {
        this.audioCtx = new AudioContext();
      }

      const stream = document.getElementById("source");
      const source = this.audioCtx.createMediaElementSource(stream);
      this.analyser = this.audioCtx.createAnalyser();
      this.analyser.fftSize = 2048;
      this.bufferLength = this.analyser.frequencyBinCount;
      this.dataArray = new Uint8Array(this.bufferLength);
      source.connect(this.analyser);
      this.analyser.connect(this.audioCtx.destination);
      this.raf = requestAnimationFrame(this.draw);
    },

    draw() {

      const WIDTH = this.canvas.width
      const HEIGHT = this.canvas.height

      this.raf = requestAnimationFrame(this.draw)

      this.analyser.getByteTimeDomainData(this.dataArray)

      this.canvasCtx.fillStyle = 'rgb(200, 200, 200)'
      this.canvasCtx.fillRect(0, 0, WIDTH, HEIGHT)

      this.canvasCtx.lineWidth = 2
      this.canvasCtx.strokeStyle = 'rgb(0, 0, 0)'

      this.canvasCtx.beginPath()

      let sliceWidth = WIDTH * 1.0 / this.bufferLength
      let x = 0


      for(let i = 0; i < this.bufferLength; i++) {

        let v = this.dataArray[i] / 128.0;
        let y = v * HEIGHT/2;

        if(i === 0) {
          this.canvasCtx.moveTo(x, y);
        } else {
          this.canvasCtx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      this.canvasCtx.lineTo(this.canvas.width, this.canvas.height/2);
      this.canvasCtx.stroke();

    }

  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.VoiceRecorder
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  
 

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

h1, h2 {
  font-size: 2rem;
  text-align: center;
  font-weight: normal;
  padding: 0.5rem 0 0 0;
}

.main-controls {
  padding: 0.5rem 0;
}

canvas 
  display block
  margin-bottom 0.5rem
  border 1px solid red
  height 60px 


#buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#buttons button {
  font-size: 1rem;
  padding: 1rem;
  width: calc(50% - 0.25rem);
}

button {
  font-size: 1rem;
  background: purple;
  text-align: center;
  color: white;
  border: none;
  transition: all 0.2s;
  padding: 0.5rem;
}

button:hover, button:focus {
  box-shadow: inset 0px 0px 10px rgba(255, 255, 255, 1);
  background: #0ae;
}

button:active {
  box-shadow: inset 0px 0px 20px rgba(0,0,0,0.5);
  transform: translateY(2px);
}


/* Make the clips use as much space as possible, and
 * also show a scrollbar when there are too many clips to show
 * in the available space */
.sound-clips {
  flex: 1;
  overflow: auto;
}

section, article {
  display: block;
}

.clip {
  padding-bottom: 1rem;
}

audio {
  width: 100%;
  display: block;
  margin: 1rem auto 0.5rem;
}

.clip p {
  display: inline-block;
  font-size: 1rem;
}

.clip button {
  font-size: 1rem;
  float: right;
}

button.delete {
  background: #f00;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
} 

button.play {
  background: green;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
}

/* Toggled State of information box */
input[type=checkbox]:checked ~ aside {
  transform: translateX(0);
}

/* Cursor when clip name is clicked over */

.clip p {
  cursor: pointer;
}

/* Adjustments for wider screens */
@media all and (min-width: 800px) {
  /* Don't take all the space as readability is lost when line length
     goes past a certain size */
  .wrapper {
    width: 90%;
    max-width: 1000px;
    margin: 0 auto;
  }
}


</style>


